import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { EssorButton } from '../index';
import { ExtendProps } from '../essorButton';

const SaveButton: FunctionComponent<ExtendProps> = ({ label, ...others }) => {
  const { t } = useTranslation();
  return (
    <EssorButton type="check" size="tiny" {...others}>
      {label || t('buttonSave')}
    </EssorButton>
  );
};

SaveButton.defaultProps = {
  disabled: false,
  floated: undefined,
  label: undefined,
};

export default SaveButton;
